module.exports = __webpack_public_path__ + "img/vegan.60363741.svg";